import { supabase } from '@/auth/supabase';
import { ROUTE_NAMES } from '@/constants/routeNames';
import { isString } from '@/utils';
import { trackEvent } from '@/utils/analytics';
import { setUserId } from '@amplitude/analytics-browser';
import googleOneTap from 'google-one-tap';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

export function useOneTap() {
  const router = useRouter();

  onMounted(() => {
    if (!clientId || !isString(clientId)) {
      return;
    }
    googleOneTap(
      {
        client_id: clientId,
        auto_select: false,
        cancel_on_tap_outside: true,
        context: 'use',
        ux_mode: 'popup',
      },
      async ({ credential }) => {
        const { data } = await supabase.auth.signInWithIdToken({
          token: credential,
          provider: 'google',
        });
        if (data.user) {
          setUserId(data.user.email);
          trackEvent('Sign in', {
            user_id: data.user.email,
            email: data.user.email,
            provider: 'google',
            source: 'one tap',
          });
          void router.push({ name: ROUTE_NAMES.HOME });
        }
      },
    );
  });
}
